module.exports = __webpack_public_path__ + "static/media/logo-portalcompraspublicas.abd55bc3.svg";